<template>
    <div id="basicas-wrapper">
        <BannerBasicas :top-banner="topBanner" />
        <ContentBasicas
            :data="data"
            :basic-products="basicsProducts"
            :pima-banner="pimaBanner"
            :with-pocket-products="withPocketProducts"
            :other-products="otherProducts"
            :kit-basics-products="kitBasicsProducts"
        />
        <DescriptionBasicas />
    </div>
</template>

<script>
    import BannerBasicas from './content/BannerBasicas.vue';
    import ContentBasicas from './content/ContentBasicas.vue';
    import DescriptionBasicas from './content/DescriptionBasicas.vue';
    import { basicsCollectionService } from '../../../common/service/resource';

    export default {
        name: 'ColecoesBasicas',
        el: '#colecoes-basicas-vue',
        components: { BannerBasicas, ContentBasicas, DescriptionBasicas },

        data() {
            return {
                topBanner: {
                    desktop_image: null,
                    mobile_image: null,
                },
                pimaBanner: {
                    desktop_image: null,
                    mobile_image: null,
                },
                basicsProducts: [],
                otherProducts: [],
                withPocketProducts: [],
                kitBasicsProducts: [],

                data: [
                    {
                        title: 'Camisetas Básicas Chico Rei',
                        main: true,
                        description:
                            'Uma coisa é certa, a camiseta básica da Chico Rei promete te acompanhar por onde você for. Feita com fios 100% algodão e disponível em diferentes tamanhos, cores e modelagens, nossa camiseta básica vai com você do trabalho ao encontro com os amigos. Confira nossa seleção!',
                        type: 'basicas',
                        categoryUrl: this.$scope.URL + 'camiseta/linha-basica/',
                    },
                    {
                        title: 'Laranja é a cor da estação e não poderia ficar de fora da nossa Linha Básica',
                        main: false,
                        description:
                            'O que não pode faltar no seu look de verão? Uma camiseta básica com um toque de cor. A sorte é que nosso lançamento na Cor da Estação reúne os dois em uma só peça: garanta já a sua camiseta Laranja Damasco, refrescante do jeito que a gente gosta ;)',
                        type: 'estacao',
                        categoryUrl: this.$scope.URL + 'loja/laranja/',
                    },
                    {
                        title: 'Camisetas Pima: coleção Malhas Especiais',
                        main: false,
                        description:
                            'Um dos melhores algodões do mundo chega à Chico Rei para dar vida a nossa coleção de Camisetas Pima. Feito com uma das fibras mais longas e finas que existem, esse algodão garante mais maciez e durabilidade às camisetas. Além disso, por se tratar de um tecido feito a partir de fibras naturais, ele possui tramas respiráveis que proporcionam uma sensação de conforto ainda maior.',
                        type: 'pima',
                        categoryUrl: this.$scope.URL + 'camiseta/algodao-pima/',
                    },
                    {
                        title: 'Kit Camisetas Básicas: 1 é bom, mas 3 é muito mió',
                        main: false,
                        description:
                            'Feita com fios 100% algodão nossas camisetas estão disponíveis em diferentes tamanhos, cores e modelagens. Com o Kit de Camisetas Básicas da Chico Rei você recebe 3 peças de uma só vez e dá aquele toque de charme ao seu visual com peças clássicas, versáteis e estilosas.',
                        type: 'kit-basicas',
                    },
                    {
                        title: 'Confira algumas peças para compor o visual',
                        main: false,
                        description:
                            'Para além das camisetas básicas, nosso site também conta com diversas peças para te ajudar a se vestir de personalidade por onde você for, com calças, bermudas, meias e muito mais. Aproveita que cê já tá por aqui e dá uma olhada na seleção especial que preparamos!',
                        type: 'outros-produtos',
                        content: [
                            {
                                title: 'Veja nossas calças',
                                imageUrl:
                                    this.$scope.CDN_IMAGES +
                                    '/images/hotsites/colecoes-basicas/outros-produtos/7a663ad1e4d9907d058d4e65416c44ec.png?auto=compress,format&q=65',
                                productUrl: this.$scope.URL + 'loja/calcas/',
                            },
                            {
                                title: 'Veja nossas bermudas',
                                imageUrl:
                                    this.$scope.CDN_IMAGES +
                                    '/images/hotsites/colecoes-basicas/outros-produtos/ae0914d3fb842876a2659f1dc9f462da.png?auto=compress,format&q=65',
                                productUrl: this.$scope.URL + 'loja/bermuda/',
                            },
                            {
                                title: 'Veja nossas meias',
                                imageUrl:
                                    this.$scope.CDN_IMAGES +
                                    '/images/hotsites/colecoes-basicas/outros-produtos/beaf1760-ef63-11ed-bebf-33a5af9ce76f.avif?auto=compress,format&q=65',
                                productUrl: this.$scope.URL + 'meia/',
                            },
                        ],
                    },
                    {
                        title: 'Camisetas com Bolso na Chico Rei',
                        main: false,
                        description:
                            'A beleza mora no detalhe e nossas camisetas com bolso sabem muito bem disso. Além de carregar todo o conforto e qualidade da linha básica, elas ainda possuem um bolso super charmoso que deixa a peça ainda mais bonita e estilosa. Conheça nossa seleção de camisetas com bolso.',
                        type: 'bolso',
                        categoryUrl: this.$scope.URL + 'camiseta/camisetas-com-bolso/',
                    },
                ],
            };
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData() {
                basicsCollectionService.getInfo().then((response) => {
                    let topBanner = response.data.data.filter(
                        (banner) => banner.type === 'top_banner'
                    )[0];
                    let pimaBanner = response.data.data.filter(
                        (banner) => banner.type === 'pima_banner'
                    )[0];
                    this.topBanner.desktop_image = topBanner.desktop_image;
                    this.topBanner.mobile_image = topBanner.mobile_image;
                    this.pimaBanner.desktop_image = pimaBanner.desktop_image;
                    this.pimaBanner.mobile_image = pimaBanner.mobile_image;

                    this.basicsProducts = response.data.data.filter(
                        (product) => product.type === 'basics_list'
                    );

                    this.otherProducts = response.data.data.filter(
                        (product) => product.type === 'complete_your_look'
                    );

                    this.kitBasicsProducts = response.data.data.filter(
                        (product) => product.type === 'kit_basics'
                    );

                    this.withPocketProducts = response.data.data.filter(
                        (product) => product.type === 'with_pocket'
                    );

                    this.basicsProducts.map((product) => {
                        product.product.data.price = this.parsePrice(product.product.data.price);
                    });

                    this.otherProducts.map((product) => {
                        product.product.data.price = this.parsePrice(product.product.data.price);
                    });

                    this.kitBasicsProducts.map((product) => {
                        product.product.data.price = this.parsePrice(product.product.data.price);
                    });

                    this.withPocketProducts.map((product) => {
                        product.product.data.price = this.parsePrice(product.product.data.price);
                    });
                });
            },

            parsePrice(value) {
                return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                }).format(value);
            },
        },
    };
</script>
